import { render, staticRenderFns } from "./InterpretationTable.vue?vue&type=template&id=a103b434&scoped=true&"
import script from "./InterpretationTable.vue?vue&type=script&lang=js&"
export * from "./InterpretationTable.vue?vue&type=script&lang=js&"
import style0 from "./InterpretationTable.vue?vue&type=style&index=0&id=a103b434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a103b434",
  null
  
)

export default component.exports